import React from "react";
import PropType from "prop-types";
import "./SportSelection.css";
import ShadowCard from "../../../../ShadowCard";

export default function ItemSelection(props) {
  return (
    <div id="gm-sport-selection">
      <ul className="gm-sport-list">
        {props.items
          ? props.items.map((item) => {
              return (
                <ShadowCard key={item.id} width={"100px"} height={"100px"}>
                  <li
                    className="gm-sport-option"
                    onClick={(e) => props.onClick(e, item)}
                    onKeyPress={(e) => props.onClick(e, item)}
                    role="menuitem"
                  >
                    {item.name}
                  </li>
                </ShadowCard>
              );
            })
          : null}
      </ul>
    </div>
  );
}

ItemSelection.propTypes = {
  items: PropType.arrayOf(PropType.object).isRequired,
  onClick: PropType.func.isRequired,
};
